export default {
    typeOptions:
        [{ label: "宣传活动", value: 1 },
        { label: "核销活动", value: 2 },
        { label: "报名活动", value: 3 }],
    questionType:
        [{ label: "单选", code: 1 },
        { label: "多选", code: 2 },
        { label: "输入框", code: 3 },
            // { label: "上传图片", code: 4 }
        ],
        option1:[{ label: "统一推送", value: 1 },
          { label: "独立推送", value: 2 }]
}